<div class="space-y-4">
  <!-- Toolbar -->
  <div class="flex items-center justify-between gap-2 flex-wrap">
    <button
      type="button"
      (click)="volver()"
      class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700 flex items-center gap-1.5">
      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
      </svg>
      Volver
    </button>

    @if (ticket) {
      <div class="flex items-center gap-1.5 flex-wrap justify-end">
        <button type="button" (click)="editar()"
          class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700">
          Editar
        </button>

        @if (canReopen()) {
          <button type="button" (click)="abrirAccion('reopen')"
            class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors bg-yellow-100 text-yellow-700 hover:bg-yellow-200 dark:bg-yellow-900/30 dark:text-yellow-400 dark:hover:bg-yellow-900/50">
            Reabrir
          </button>
        }

        <button type="button" (click)="abrirAccion('escalate')"
          class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors bg-orange-100 text-orange-700 hover:bg-orange-200 dark:bg-orange-900/30 dark:text-orange-400 dark:hover:bg-orange-900/50">
          Escalar
        </button>

        @if (canResolve()) {
          <button type="button" (click)="abrirAccion('resolve')"
            class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors bg-green-600 text-white hover:bg-green-700">
            Resolver
          </button>
        }

        <!-- Menú desplegable de acciones de jerarquía/vínculos.
             Inc 73: oculto cuando el ticket es un subticket (no puede tener
             subtickets ni gestionar vínculos). -->
        @if (!esSubTicket) {
        <div class="relative inline-block" (click)="$event.stopPropagation()">
          <button type="button" (click)="toggleLinksMenu()"
            [attr.aria-expanded]="linksMenuOpen"
            class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 inline-flex items-center gap-1.5">
            Vínculos
            <svg class="w-3 h-3 transition-transform" [class.rotate-180]="linksMenuOpen" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
            </svg>
          </button>

          @if (linksMenuOpen) {
            <div class="absolute right-0 mt-2 w-52 z-dropdown overflow-hidden rounded-lg border border-gray-200 bg-white shadow-lg dark:border-gray-700 dark:bg-gray-900">
              <ul class="py-1">
                <li>
                  <button type="button" (click)="abrirAccion('sub-ticket')"
                    class="flex w-full items-center gap-2 px-3 py-2 text-left text-sm text-gray-700 hover:bg-gray-50 dark:text-gray-200 dark:hover:bg-gray-800">
                    Crear sub-ticket
                  </button>
                </li>
                <li>
                  <button type="button" (click)="abrirAccion('merge')"
                    class="flex w-full items-center gap-2 px-3 py-2 text-left text-sm text-gray-700 hover:bg-gray-50 dark:text-gray-200 dark:hover:bg-gray-800">
                    Fusionar tickets
                  </button>
                </li>
                <li>
                  <button type="button" (click)="abrirAccion('split')"
                    class="flex w-full items-center gap-2 px-3 py-2 text-left text-sm text-gray-700 hover:bg-gray-50 dark:text-gray-200 dark:hover:bg-gray-800">
                    Dividir ticket
                  </button>
                </li>
              </ul>
            </div>
          }
        </div>
        }
      </div>
    }
  </div>

  <!-- Loading -->
  @if (loading) {
    <div class="flex justify-center items-center py-12">
      <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-brand-500"></div>
    </div>
  }

  <!-- Error -->
  @if (error) {
    <div class="p-4 bg-error-50 border border-error-200 rounded-lg dark:bg-error-500/10 dark:border-error-500/20">
      <p class="text-error-600 dark:text-error-400">{{ error }}</p>
    </div>
  }

  <!-- Layout dos columnas (sidebar + main) -->
  @if (ticket) {
  <div class="grid grid-cols-1 lg:grid-cols-3 gap-4">

    <!-- Sidebar -->
    <aside class="lg:col-span-1 space-y-4">
      <!-- Metadata -->
      <div class="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-xl p-5 space-y-3">
        <div>
          <p class="text-xs text-gray-500 dark:text-gray-400">Pipeline</p>
          <p class="text-sm font-medium text-gray-900 dark:text-white">{{ getPipelineName(ticket.idPipeline) }}</p>
        </div>
        <div>
          <p class="text-xs text-gray-500 dark:text-gray-400">Etapa</p>
          <p class="text-sm font-medium text-gray-900 dark:text-white">{{ getStageName(ticket.idStage) }}</p>
        </div>
        <div>
          <p class="text-xs text-gray-500 dark:text-gray-400">Asignado a</p>
          <p class="text-sm font-medium text-gray-900 dark:text-white">{{ ticket.ownerUserName || '-' }}</p>
        </div>
        <div>
          <p class="text-xs text-gray-500 dark:text-gray-400">Creador</p>
          <!-- Sin creador = lo abrió una automatización (chatflow, formulario, correo): «Sistema»,
               que es un autor concreto, no un dato que falte. -->
          <p class="text-sm font-medium text-gray-900 dark:text-white">{{ ticket.creatorUserName || 'Sistema' }}</p>
        </div>
        <div>
          <p class="text-xs text-gray-500 dark:text-gray-400">Origen</p>
          <p class="text-sm font-medium text-gray-900 dark:text-white">{{ origenLabel(ticket.source) }}</p>
        </div>
      </div>

      <!-- Asociaciones -->
      <div class="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-xl p-5 space-y-3">
        <p class="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide">Asociaciones</p>
        <div>
          <p class="text-xs text-gray-500 dark:text-gray-400">Contacto</p>
          <p class="text-sm font-medium text-gray-900 dark:text-white">{{ ticket.contactName || (ticket.idContact ? 'Contacto sin nombre disponible' : '—') }}</p>
        </div>
        <div>
          <p class="text-xs text-gray-500 dark:text-gray-400">Empresa</p>
          <p class="text-sm font-medium text-gray-900 dark:text-white">{{ ticket.companyName || (ticket.idCompany ? 'Empresa sin nombre disponible' : '—') }}</p>
        </div>
        @if (ticket.idDeal != null) {
          <div>
            <p class="text-xs text-gray-500 dark:text-gray-400">Negocio</p>
            <p class="text-sm font-medium text-gray-900 dark:text-white">{{ ticket.dealName || 'Negocio sin nombre disponible' }}</p>
          </div>
        }
        <!-- Inc 73: ticket padre (sólo lectura) cuando este ticket es un subticket. -->
        @if (esSubTicket) {
          <div>
            <p class="text-xs text-gray-500 dark:text-gray-400">Ticket padre</p>
            <button type="button"
              (click)="verTicketPadre()"
              class="text-sm font-medium text-brand-600 dark:text-brand-400 hover:underline text-left">
              {{ parentLabel }}
            </button>
          </div>
        }
        @if (ticket.idLead != null) {
          <div>
            <p class="text-xs text-gray-500 dark:text-gray-400">Creado desde lead</p>
            <button type="button"
              (click)="verLead(ticket.idLead)"
              class="text-sm font-medium text-brand-600 dark:text-brand-400 hover:underline text-left">
              {{ ticket.leadName || ('Lead #' + ticket.idLead) }}
            </button>
          </div>
        }
      </div>

      <!-- Timestamps -->
      <div class="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-xl p-5 space-y-3">
        <p class="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide">Tiempos</p>
        <div>
          <p class="text-xs text-gray-500 dark:text-gray-400">Creado</p>
          <p class="text-sm font-medium text-gray-900 dark:text-white">{{ ticket.datetimeCreated | date:'dd/MM/yyyy HH:mm' }}</p>
        </div>
        <div>
          <p class="text-xs text-gray-500 dark:text-gray-400">Actualizado</p>
          <p class="text-sm font-medium text-gray-900 dark:text-white">{{ ticket.datetimeUpdated | date:'dd/MM/yyyy HH:mm' }}</p>
        </div>
        @if (ticket.firstResponseAt) {
          <div>
            <p class="text-xs text-gray-500 dark:text-gray-400">1ra respuesta</p>
            <p class="text-sm font-medium text-gray-900 dark:text-white">{{ ticket.firstResponseAt | date:'dd/MM/yyyy HH:mm' }}</p>
          </div>
        }
        @if (ticket.resolvedAt) {
          <div>
            <p class="text-xs text-gray-500 dark:text-gray-400">Resuelto</p>
            <p class="text-sm font-medium text-gray-900 dark:text-white">{{ ticket.resolvedAt | date:'dd/MM/yyyy HH:mm' }}</p>
          </div>
        }
        @if (ticket.reopenedCount > 0) {
          <div>
            <p class="text-xs text-gray-500 dark:text-gray-400">Reaberturas</p>
            <p class="text-sm font-medium text-gray-900 dark:text-white">{{ ticket.reopenedCount }}</p>
          </div>
        }
      </div>

    </aside>

    <!-- Main: tabs -->
    <main class="lg:col-span-2 bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-xl p-6">
      <app-tickets-detail-tabs
        [ticket]="ticket"
        [priorities]="priorities"
        [statuses]="statuses"
        [categories]="categories"
        [pipelines]="pipelines"
        [stages]="stages"
        [showHeader]="true"
        (subTicketCreated)="onSubTicketCreadoDesdeTabs($event)">
      </app-tickets-detail-tabs>
    </main>

  </div>
  }

  <!-- Modal multi-acción -->
  <app-tickets-actions-modals
    [ticket]="ticket"
    [action]="activeAction"
    [statuses]="statuses"
    [priorities]="priorities"
    [categories]="categories"
    [rootCauses]="rootCauses"
    (closed)="cerrarAccion()"
    (saved)="onAccionCompletada($event)">
  </app-tickets-actions-modals>
</div>
